import { render } from "./DefaultPostRelatedTopicSectionNewsCmp.vue?vue&type=template&id=1fc4434d"
import script from "./DefaultPostRelatedTopicSectionNewsCmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostRelatedTopicSectionNewsCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__